import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class InitiativesListFilterSlideoverComponent extends Component {
  get columnOptions() {
    return this.args.columnOptions.map((item) => ({
      label: item.label,
      value: item.label,
      show: item.show,
    }));
  }

  @action
  onColumnSelect(values) {
    this.args?.onColumnSelect?.(values);
  }
}
